import React from "react";
import styled, { keyframes } from "styled-components";

import greece from "../../images/retreat/flags/greece.svg";
import morocco from "../../images/retreat/flags/morrocco.svg";
import italy from "../../images/retreat/flags/italy.svg";
import england from "../../images/retreat/flags/england.png";
import indiaMumbai from "../../images/retreat/flags/india - Mumbai.png";
import indiaJaipur from "../../images/retreat/flags/india - Jaipur.png";
import ireland from "../../images/retreat/flags/ireland.png";
import scotland from "../../images/retreat/flags/scotland.png";
import sriLanka from "../../images/retreat/flags/sri lanka.png";
import switzerland from "../../images/retreat/flags/switzerland.png";
import thailand from "../../images/retreat/flags/thailand.png";
import usa from "../../images/retreat/flags/usa.png";
import wales from "../../images/retreat/flags/wales.png";
import greatBritain from "../../images/retreat/flags/great britain.png";

// Flags displayed in the scrolling banner. Greece, Morocco and Italy are
// highlighted as featured retreat locations.
const flagData = [
  { src: england, name: "England" },
  { src: greece, name: "Greece", featured: true },
  { src: indiaMumbai, name: "India - Mumbai" },
  { src: indiaJaipur, name: "India - Jaipur" },
  { src: ireland, name: "Ireland" },
  { src: scotland, name: "Scotland" },
  { src: morocco, name: "Morocco", featured: true },
  { src: switzerland, name: "Switzerland" },
  { src: usa, name: "USA" },
  { src: greatBritain, name: "Great Britain" },
  { src: italy, name: "Italy", featured: true },
  { src: sriLanka, name: "Sri Lanka" },
  { src: thailand, name: "Thailand" },
  { src: wales, name: "Wales" },
];

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const Wrapper = styled.div`
  ${(props) =>
    props.isFilterActive &&
    `
      background-color: rgba(0, 0, 0, 0);
      filter: grayscale(100%);
    `}
  padding: 20px;
  overflow: hidden;
  width: auto;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

const Scroller = styled.div`
  overflow: hidden;
`;

const ScrollerTrack = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  will-change: transform;
  animation: ${scroll} 36s linear infinite;

  @media (max-width: 768px) {
    animation-duration: 20s;
  }
`;

const FlagItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  margin: 0 clamp(16px, 4vw, 40px);
  border-radius: 10px;
  padding: 5px;
`;

const FeaturedRibbon = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  background: gold;
  color: black;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 5px;
  border-bottom-right-radius: 5px;
`;

const FlagImage = styled.img`
  width: 150px;
  height: 100px;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 110px;
    height: 75px;
  }
`;

const CountryName = styled.span`
  margin-top: 10px;
  font-weight: bold;
`;

const RetreatLocations = ({ isFilterActive }) => {
  const duplicatedFlags = [...flagData, ...flagData];
  return (
    <Wrapper isFilterActive={isFilterActive}>
      <Title>Retreat Locations</Title>
      <Scroller>
        <ScrollerTrack>
          {duplicatedFlags.map((flag, index) => (
            <FlagItem key={index}>
              {flag.featured && <FeaturedRibbon>Featured</FeaturedRibbon>}
              <FlagImage src={flag.src} alt={flag.name} />
              <CountryName>{flag.name}</CountryName>
            </FlagItem>
          ))}
        </ScrollerTrack>
      </Scroller>
    </Wrapper>
  );
};

export default RetreatLocations;

